<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div>
      <div
        class="card-header first-header card-expandable"
        id="headingOne"
        data-toggle="collapse"
        data-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
        <div class="title">
          <i class="feather-icon icon-file-plus"></i>
          <h5 class="mb-0">รายละเอียดการขอค้ำประกัน</h5>
        </div>
      </div>
      <div
        id="collapseOne"
        class="collapse show"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div class="card-body compact-padding">
          <div class="default-padding">
            <div class="data-display mb-3">
              <table class="two-col-data">
                <tbody>
                  <tr>
                    <th>Tax ID</th>
                    <td class="important">{{ appVo.requesterTaxId }}</td>
                  </tr>

                  <tr>
                    <th>ชื่อลูกค้า (Th)</th>
                    <td>{{ appVo.requesterNameTh }}</td>
                  </tr>

                  <tr>
                    <th>ชื่อลูกค้า (En)</th>
                    <td>{{ appVo.requesterNameEn }}</td>
                  </tr>

                  <tr>
                    <th>ที่อยู่ลูกค้า</th>
                    <td>
                      {{ appVo.requesterAddr }}&nbsp;&nbsp;{{
                        appVo.requesterSubDistrict
                      }}&nbsp;&nbsp;{{ appVo.requesterDistrict }}&nbsp;&nbsp;{{ appVo.requesterProvince }}&nbsp;&nbsp;{{
                        appVo.requesterZipcode
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)</label>
                <v-select
                  v-model="beneficiary"
                  name="beneficiary"
                  class="vue-select1"
                  ref="input"
                  v-validate="'required'"
                  :class="{
                    input: true,
                    'is-danger': errors.has('beneficiary'),
                  }"
                  @input="
                    getLgTypeList()
                      .then(() => {
                        return getFormNoList();
                      })
                      .then(() => {
                        return getDocTypeList();
                      })
                      .then(() => {
                        return getCommitmentList();
                      })
                      .then(() => {
                        return getAccountByCommNo();
                      })
                      .then(() => {
                        return getFeeAmount();
                      })
                  "
                  :options="beneficiaryList"
                  label="nameTH"
                >
                </v-select>
                <!--<select
                  v-model="beneficiary"
                  name="beneficiary"
                  class="form-control"
                  ref="input"
                  @change="getLgTypeList().then(() => {   return getFormNoList(); }).then(() => { return getDocTypeList(); }).then(() => {   return getCommitmentList(); }).then(() => {   return getAccountByCommNo(); }).then(() => {   return getFeeAmount(); });"
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('beneficiary') }"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in beneficiaryList"
                    v-bind:key="`${option.taxid}-${option.nameTH}`"
                    v-bind:value="{ beneTaxId: option.taxid, beneGroup: option.group, beneName: option.nameTH}"
                  >{{ option.nameTH }}</option>
                </select>-->
                <span v-show="errors.has('beneficiary')" class="help is-danger"
                  >ระบุ ผู้รับผลประโยชน์</span
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>ประเภทค้ำประกัน</label>
                <select
                  v-model="lgTypeObj"
                  name="lgTypeObj"
                  ref="refLgType"
                  class="form-control"
                  @change="
                    getFormNoList()
                      .then(() => {
                        return getDocTypeList();
                      })
                      .then(() => {
                        return getCommitmentList();
                      })
                      .then(() => {
                        return getAccountByCommNo();
                      })
                      .then(() => {
                        return getFeeAmount();
                      })
                  "
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('lgTypeObj') }"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in custLgTypeList"
                    v-bind:value="{
                      contingentId: option.contingentTypeId,
                      mtContingentId: option.mtContingentId,
                    }"
                    :key="
                      `${option.contingentTypeId}-${
                        option.contingentTypeNameTh
                      }`
                    "
                    >{{ option.contingentTypeNameTh }}</option
                  >
                </select>
                <span v-show="errors.has('lgTypeObj')" class="help is-danger"
                  >ระบุ ประเภทค้ำประกัน</span
                >
              </div>

              <div
                class="form-group col-md-6"
                v-bind:class="{ hideForm: isHideForm }"
              >
                <label>รหัสแบบฟอร์มหนังสือค้ำประกัน</label>
                <select
                  v-model="lgFormNo"
                  name="lgFormNo"
                  ref="refLgFormNo"
                  class="form-control"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('lgFormNo') }"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in lgFormList"
                    v-bind:value="option.lgFormNo"
                    :key="option.lgFormNo"
                    >{{ option.lgFormNo }}</option
                  >
                </select>
                <span v-show="errors.has('lgFormNo')" class="help is-danger"
                  >ระบุ รหัสแบบฟอร์มหนังสือค้ำประกัน</span
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-radio
                    v-model="accountType"
                    v-bind:value="'COM'"
                    name="accountType"
                    v-validate="{ required: true }"
                    >หมายเลขบัญชีวงเงิน</b-form-radio
                  >

                <!--<label>หมายเลขบัญชีวงเงิน</label>-->
                <select
                  v-model="commNo"
                  name="commNo"
                  ref="scommNo"
                  class="form-control"
                  @change="getAccountByCommNo()
                      .then(() => {
                        return getGuaranteeList();
                      })
                      .then(() => {
                        return getFeeAmount();
                      })
                  "
                  v-validate="{ required: this.accountType == 'COM' }"
                  :disabled="this.accountType !== 'COM'"
                  :class="{ input: true, 'is-danger': errors.has('commNo') }"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in commList"
                    v-bind:value="option.accountNo"
                    :key="`${option.accountNo}-${option.accountName}`"
                    >{{ option.accountNo }}:{{ option.accountName }}</option
                  >
                </select>
                <span v-show="errors.has('accountNo')" class="help is-danger"
                  >ระบุ หมายเลขบัญชีวงเงิน</span
                >
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-radio
                    v-model="accountType"
                    v-bind:value="'SAV'"
                    name="accountType"
                    v-validate="{ required: true }"
                    >Cash Collateral</b-form-radio
                  >
                <!--<label>Cash Collateral</label>-->
                <select
                  v-model="savAccNoItem"
                  name="savAccNoItem"
                  ref="ssavAccNoItem"
                  class="form-control"
                  :disabled="this.accountType !== 'SAV'"
                  :class="{ input: true, 'is-danger': errors.has('savAccNoItem') }"
                  v-validate="{ required: this.accountType == 'SAV' }"
                  @change="getDefaultGuaranteeList()
                           .then(() => {
                            return getGuaranteeList();
                            }).then(() => {
                            return setSaveAcc();
                          })"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in savAccList"
                    v-bind:value="option"
                    :key="`${option.accountNo}-${option.accountName}`"
                    >{{ option.accountNo }}:{{ option.accountName }}</option
                  >
                </select>
                <span v-show="errors.has('savAccNoItem')" class="help is-danger"
                  >ระบุ Cash Collateral</span
                >
              </div>
            </div>

            <!--<div class="form-row" v-if="this.accountType == 'SAV' && this.appVo.branchOwnerFlg == 'Y'">-->
            <div class="form-row" v-if="this.accountType == 'SAV'">
              <div class="form-group col-md-6">
                <label>สาขาที่ต้องการลงนามสัญญาสินเชื่อ</label>
                <v-select
                  v-model="creditBranch"
                  name="creditBranch"
                  class="vue-select1"
                  ref="input"
                  :class="{
                    input: true,
                    'is-danger': errors.has('creditBranch'),
                  }"

                  :options="creditBranchList"
                  label="branchName"
                >
                </v-select>
                <span v-show="errors.has('creditBranch')" class="help is-danger"
                  >ระบุ สาขาที่ต้องการลงนามสัญญาสินเชื่อ</span
                >
              </div>
            </div>

            <div class="option-form mb-4">
              <div class="form-group">
                <label>เพื่อค้ำประกันในนาม</label>

                <div
                  class="input-group"
                  v-for="(guarantee, index) in guaranteeList"
                  :key="`divGuarantee_+${guarantee.guaranteeTaxId}`"
                >
                  <button
                    type="button"
                    class="btn btn-secondary-custom btn-icon btn-minus"
                    @click="removeGuarantee(index)"
                  >
                    <i class="feather-icon icon-minus"></i>
                  </button>
                  <select
                    v-model="guarantee.guaranteeTaxId"
                    :name="'guarantee_' + [index] + '.guaranteeTaxId'"
                    class="form-control"
                    @change="onRequesterLChange($event, guarantee)"
                    v-validate="'required'"
                    :class="{
                      input: true,
                      'is-danger': errors.has(
                        'guarantee_' + index + '.guaranteeTaxId'
                      ),
                    }"
                  >
                    <option value="">กรุณาเลือก</option>
                    <option
                      v-for="requester in requesterList"
                      v-bind:value="requester"
                      v-bind:key="
                        `${requester.guaranteeTaxId}-${requester.guaranteeName}`
                      "
                      >{{ requester.guaranteeTaxId }}</option
                    >
                  </select>

                  <input
                    v-model="guarantee.guaranteeName"
                    :name="'guarantee_' + [index] + '.guaranteeName'"
                    type="text"
                    class="form-control"
                    :class="{
                      input: true,
                      'is-danger': errors.has(
                        'guarantee_' + index + '.guaranteeName'
                      ),
                    }"
                    v-validate="{ required: true }"
                    placeholder="ชื่อภาษาไทย"
                  />

                  <input
                    v-model="guarantee.guaranteeNameEN"
                    :name="'guarantee_' + [index] + '.guaranteeNameEN'"
                    type="text"
                    class="form-control"
                    :class="{
                      input: true,
                      'is-danger': errors.has(
                        'guarantee_' + index + '.guaranteeNameEN'
                      ),
                    }"
                    v-validate="{ required: true }"
                    placeholder="ชื่อภาษาอังกฤษ"
                  />

                  <button
                    type="button"
                    class="btn btn-secondary-custom btn-icon btn-plus"
                    @click="addGuarantee()"
                  >
                    <i class="feather-icon icon-plus"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>จำนวนเงินค้ำประกัน(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="lgAmt"
                  name="lgAmt"
                  class="form-control"
                  placeholder="กรุณากรอกจำนวน"
                  @blur="
                    getFeeAmount().then(() => {
                      return getStampAmt();
                    })
                  "
                  v-validate="{
                    required: true,
                    min_value: 1,
                    max_value:
                      this.jobPrice !== null && this.jobPrice > 0
                        ? this.jobPrice
                        : 1000000000,
                  }"
                  :class="{ input: true, 'is-danger': errors.has('lgAmt') }"
                ></vue-numeric>
                <span v-show="errors.has('lgAmt')" class="help is-danger"
                  >จำนวนเงินค้ำประกัน ไม่ถูกต้อง</span
                >
              </div>
            </div>

            <component
              :reqType="reqType"
              :lgType="lgTypeObj.contingentId"
              :beneGroup="beneficiary.group"
              :lgFormNo="lgFormNo"
              :beneTaxId="beneficiary.taxid"
              :is="dynamicBeneChild"
              v-on:childToParent="onChildChange"
              v-bind:specificVo="specificVo"
              v-bind:lgSpecificFields="lgSpecificFields"
            />

            <div class="form-row">
              <div class="form-group no-label col-md-6">
                <label>ระยะเวลาในการค้ำประกัน</label>
              </div>
            </div>

            <div class="form-row div-valign">
              <div class="form-group no-label col-md-6">
                <div class="">
                  <b-form-radio
                    v-model="periodType"
                    v-bind:value="2"
                    name="periodType"
                    v-validate="{ required: true }"
                    :disabled="this.lgFormNo=='MEA_UTL_002_TH'"
                    @change="getFeeAmount()"
                    >มีกำหนดระยะเวลา</b-form-radio
                  >

                  <div class="period">
                    <vue-numeric
                      separator=","
                      :empty-value="0"
                      v-model="periodAmt"
                      name="periodAmt"
                      id="periodAmt"
                      ref="periodAmt"
                      class="form-control"
                      placeholder="กรุณากรอกระยะเวลา"
                      :disabled="this.periodType !== 2"
                      @blur="getPeriod('num'), getFeeAmount()"
                      :class="{
                        input: true,
                        'is-danger': errors.has('periodAmt'),
                      }"
                    ></vue-numeric>
                    <span
                      v-show="errors.has('periodAmt')"
                      class="help is-danger"
                      >ระยะเวลา ไม่ถูกต้อง</span
                    >
                    <select
                      class="form-control"
                      name="periodUnit"
                      id="periodUnit"
                      ref="periodUnit"
                      v-model="periodUnit"
                      :class="{
                        input: true,
                        'is-danger': errors.has('periodUnit'),
                      }"
                      @change="getPeriod('unit'), getFeeAmount()"
                      :disabled="this.periodType !== 2"
                    >
                      <option value="">เลือก</option>
                      <option
                        v-for="unit in periodUnitList"
                        :value="unit.id"
                        :key="unit.id"
                      >
                        {{ unit.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group no-label col-md-3">
                <div class="form-row">
                  <label>ตั้งแต่วันที่</label>
                  <date-picker
                    v-model="periodStartDate1"
                    name="periodStartDate1"
                    ref="periodStartDate1"
                    lang="th"
                    format="DD/MM/YYYY"
                    :disabled="this.periodType !== 2"
                    :not-before="this.effectivePassDay"
                    placeholder
                    v-validate="{ required: this.periodType === 2 }"
                    data-vv-as="ตั้งแต่วันที่"
                    :class="{
                      input: true,
                      'is-danger': errors.has('periodStartDate1'),
                    }"
                    @change="getPeriod('startDate'), getFeeAmount()"
                    width="140px"
                  ></date-picker>
                  <span
                    class="form-error"
                    :class="{ 'text-danger': errors.has('periodStartDate1') }"
                    >{{ errors.first("periodStartDate1") }}</span
                  >
                </div>
              </div>
              <div class="form-group no-label col-md-3">
                <div class="form-row">
                  <label>ถึงวันที่</label>
                  <date-picker
                    v-model="periodEndDate"
                    name="periodEndDate"
                    ref="periodEndDate"
                    lang="th"
                    format="DD/MM/YYYY"
                    :disabled="this.periodType !== 2"
                    :not-before="
                      new Date() > this.periodStartDate1
                        ? new Date()
                        : this.periodStartDate1
                    "
                    placeholder
                    v-validate="{ required: this.periodType === 2 }"
                    data-vv-as="ถึงวันที่"
                    :class="{
                      input: true,
                      'is-danger': errors.has('periodEndDate'),
                    }"
                    @change="getPeriod('endDate'), getFeeAmount()"
                    width="140px"
                  ></date-picker>
                  <span
                    class="form-error"
                    :class="{ 'text-danger': errors.has('periodEndDate') }"
                    >{{ errors.first("periodEndDate") }}</span
                  >
                </div>
              </div>
            </div>

            <div class="form-row div-valign">
              <div class="form-group no-label col-md-3">
                <b-form-radio
                  v-model="periodType"
                  name="periodType"
                  v-bind:value="1"
                  v-validate="{ required: true }"
                  :disabled="this.accountType == 'SAV' || this.lgFormNo=='MEA_UTL_001_TH'"
                  @change="getFeeAmount()"
                  >ไม่มีกำหนดระยะเวลา</b-form-radio
                >
              </div>

              <div class="form-group no-label col-md-2">
                <label>ตั้งแต่วันที่</label>
              </div>
              <div class="form-group no-label col-md-3">
                <div class="form-row">
                  <date-picker
                    v-model="periodStartDate2"
                    name="periodStartDate2"
                    ref="periodStartDate2"
                    lang="th"
                    format="DD/MM/YYYY"
                    :disabled="this.periodType !== 1"
                    :not-before="this.effectivePassDay"
                    placeholder
                    v-validate="{ required: this.periodType === 1 }"
                    data-vv-as="ตั้งแต่วันที่"
                    :class="{
                      input: true,
                      'is-danger': errors.has('periodStartDate2'),
                    }"
                    @change="getFeeAmount()"
                    width="140px"
                  ></date-picker>
                  <span
                    class="form-error"
                    :class="{ 'text-danger': errors.has('periodStartDate2') }"
                    >{{ errors.first("periodStartDate2") }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div class="default-padding">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>ค่าธรรมเนียม</label>
              </div>
            </div>

            <div class="form-row" v-if="this.bcFlag === '1'">
              <div class="form-group col-md-6">
                <label>ค่าธรรมเนียม(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="feeAmt"
                  name="feeAmt"
                  class="form-control"
                  v-validate="{ required: true, min_value: 1 }"
                  :class="{ input: true, 'is-danger': errors.has('feeAmt') }"
                  readonly
                ></vue-numeric>
              </div>
            </div>

            <div class="form-row" v-if="this.bcFlag === '1' || this.accountType == 'SAV'">
              <div class="form-group col-md-6" v-if="this.accountType == 'COM'">
                <label>ตัดบัญชีค่าธรรมเนียมอัตโนมัติ</label>
                <input
                  v-model="accNoFee"
                  type="text"
                  class="form-control"
                  name="accNoFee"
                  v-validate="{ required: true }"
                  :class="{ input: true, 'is-danger': errors.has('accNoFee') }"
                  placeholder
                  readonly
                />
              </div>
              <div class="form-group col-md-6" v-if="this.accountType == 'SAV'">
              <label>ตัดบัญชีค่าธรรมเนียมอัตโนมัติ</label>
              <select
                  v-model="accNoFeeItem"
                  name="accNoFeeItem"
                  ref="saccNoFeeItem"
                  class="form-control"
                  :class="{ input: true, 'is-danger': errors.has('accNoStamp') }"
                  @change="setAccBalFee()"
                  v-validate="{ required: this.accountType == 'SAV' }"
                  
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in feeAccList"
                    v-bind:value="option"
                    :key="`${option.accountNo}-${option.availBalAmt}`"
                    >{{ option.accountNo }}:{{ option.accountName }}</option
                  >
                </select>
                <span v-show="errors.has('accNoFeeItem')" class="help is-danger"
                  >ระบุ บัญชีค่าธรรมเนียม</span
                >
                </div>
              <div class="form-group col-md-6">
                <label>จำนวนเงินคงเหลือในบัญชี(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="accBalFee"
                  name="accBalFee"
                  class="form-control"
                  readonly
                ></vue-numeric>
              </div>
            </div>

            <div class="form-row" v-if="this.bcFlag !== '1'">
              &nbsp;
              <span class="text-red"
                >ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร</span
              >
            </div>
          </div>

          <hr />

          <div class="default-padding">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>ค่าอากรแสตมป์</label>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label>ต้นฉบับ(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="majorStampAmt"
                  name="majorStampAmt"
                  class="form-control"
                  readonly
                ></vue-numeric>
              </div>
              <div class="form-group col-md-4">
                <label>จำนวนเงินรวม(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="dutyStampAmt"
                  name="dutyStampAmt"
                  class="form-control"
                  readonly
                ></vue-numeric>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6" v-if="this.accountType == 'COM'">
                <label>ตัดบัญชีค่าอากรแสตมป์อัตโนมัติ</label>
                <input
                  v-model="accNoStamp"
                  type="text"
                  class="form-control"
                  name="accNoStamp"
                  v-validate="{ required: true }"
                  :class="{
                    input: true,
                    'is-danger': errors.has('accNoStamp'),
                  }"
                  placeholder
                  readonly
                />
              </div>
              <div class="form-group col-md-6" v-if="this.accountType == 'SAV'">
              <label>ตัดบัญชีค่าอากรแสตมป์อัตโนมัติ</label>
              <select
                  v-model="accNoStampItem"
                  name="accNoStampItem"
                  ref="saccNoStampItem"
                  class="form-control"
                  :class="{ input: true, 'is-danger': errors.has('accNoStamp') }"
                  @change="setAccBalStamp()"
                  v-validate="{ required: this.accountType == 'SAV' }"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in stampAccList"
                    v-bind:value="option"
                    :key="`${option.accountNo}-${option.availBalAmt}`"
                    >{{ option.accountNo }}:{{ option.accountName }}</option
                  >
                </select>
                <span v-show="errors.has('accNoStampItem')" class="help is-danger"
                  >ระบุ บัญชีค่าอากรแสตมป์</span
                >
                </div>
              <div class="form-group col-md-6">
                <label>จำนวนเงินคงเหลือในบัญชี(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="accBalStamp"
                  name="accBalStamp"
                  class="form-control"
                  readonly
                ></vue-numeric>
              </div>
            </div>
          </div>

          <div
            class="card-header first-header card-expandable"
            id="headingOne"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div class="title">
              <i class="feather-icon icon-file-plus"></i>
              <h5 class="mb-0">เอกสารประกอบเพิ่มเติม</h5>
            </div>
          </div>
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          ></div>
          <div class="card-body compact-padding">
            <div class="doctype-body">
              <div
                class="default-padding"
                v-for="(item, index) in docTypeList"
                :key="index"
                v-bind:id="'docType' + index"
              >
                <p>
                  <span
                    class="text-red result-bold"
                    v-if="item.mandatFlag === 'Y'"
                    >*</span
                  >
                  {{ item.docTypeDesc }}
                </p>
                <vue-dropzone
                  v-bind:ref="'myVueDropzone' + index"
                  v-bind:id="'dropzone' + index"
                  v-on:vdropzone-removed-file="imageRemoved"
                  v-on:vdropzone-error="uploadError"
                  v-on:vdropzone-processing="
                    initUpload('myVueDropzone' + index, item.docTypeId)
                  "
                  v-on:vdropzone-success="successUpload"
                  :options="dropzoneOptions"
                  :destroyDropzone="false"
                ></vue-dropzone>
                <br /><br />
              </div>
              <div class="result-center">
                <i class="fa fa-cloud-upload"></i> Upload เอกสารแนบได้ไม่เกิน 10
                ไฟล์ (เฉพาะ PDF และ รูป ขนาดไม่เกิน 10MB)
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-4">
            <div class="col-6 col-sm-5 col-lg-5 col-xl-4">
              <div class="cta-btn single-btn">
                <button class="btn btn-lg btn-primary-ktb" type="submit">
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";

import { apiClient } from "@/utils/apiClient";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import Lgmain from "../request/lgmain";
import moment from "moment";

export default {
  props: ["beneCode", "lg", "reqType", "lgType", "specificVo", "lgSpecificFields"],
  components: {
    AppFooter,
    AppHeader,
    vueDropzone: vue2Dropzone,
    DatePicker,
    Lgmain,
    moment,
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  data() {
    return {
      isHideForm: false,
      refDropZone: "",
      reqNo: "",
      reqTypeNew: "",
      reqTypeExt: "",
      reqTypeInc: "",
      appVo: [],
      requesterList: [],
      beneficiary: {
        beneTaxId: localStorage.getItem("beneTaxId"),
        beneGroup: localStorage.getItem("beneGroup"),
        beneName: localStorage.getItem("beneName"),
      },
      lgTypeObj: {
        contingentId: localStorage.getItem("contingentId"),
        mtContingentId: localStorage.getItem("mtContingentId"),
        //lgFormNo: localStorage.getItem("lgFormNo")
      },
      guaranteeList: [
        {
          guaranteeTaxId: "",
          guaranteeName: "",
          guaranteeNameEN: "",
        },
      ],
      beneficiaryList: [],
      creditBranchList: [],
      //lgType: localStorage.getItem("lgType"),
      //specificVo:[],
      custLgTypeList: [],
      periodUnitList: [
        { id: "dd", name: "วัน" },
        { id: "mm", name: "เดือน" },
        { id: "yyyy", name: "ปี" },
      ],
      commList: [],
      cashCollAccList: [],
      savAccList: [],
      feeAccList: [],
      stampAccList: [],
      accountType:"COM",
      periodType: "",
      commNo: "",
      savAccNo: "",
      savAccNoItem: "",
      savAccNoBal: "",
      majorStampAmt: "",
      minorStampAmt: "",
      dutyStampAmt: "",
      periodStartDate: "",
      periodStartDate1: "",
      periodStartDate2: "",
      periodEndDate: "",
      periodAmt: "",
      periodUnit: "",
      lgAmt: "",
      feeAmt: "",
      accNoFee: "",
      accNoFeeItem: "",
      accBalFee: "",
      accNoStamp: "",
      accNoStampItem:"",
      accBalStamp: "",
      ctrNo: "",
      ctrName: "",
      ctrDate: "",
      caNo: "",
      securityNo: "",
      bpNo: "",
      meterNo: "",
      jobPrice: "",
      middlePrice: "",
      beneficiaryRemark: "",
      feeDebitAccountList: [],
      effectivePassDay: "",
      bcFlag: "0",
      lgFormNo: "",
      mtContingentId: "",
      lgFormList: [],
      docTypeList: [],
      docSeq: "",
      modifyFlag: "",
      dropzoneOptions: {
        //url: "http://localhost:8080/api/elg/attachFile/"+localStorage.getItem("registerVerifyId")+"/"+localStorage.getItem("reqNo"),
        // url: "https://web1.uat.ktb:11001/ELGPortalService/api/elg/attachFile/"+localStorage.getItem("registerVerifyId")+"/"+localStorage.getItem("reqNo"),
        //url:"https://web1.uat.ktb:11001/ELGPortalService/api/elg/attachFile/",
        url: process.env.VUE_APP_ROOT_API + "/api/elg/attachFile/",
        thumbnailWidth: 100,
        maxFilesize: 10, //10MB
        maxFiles: 10, //10 Files
        addRemoveLinks: true,
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.token,
        },
        dictDefaultMessage: "<i class='fa fa-plus'></i> อัพโหลดไฟล์",
        acceptedFiles: "image/*,application/pdf",
        init: function() {
          this.on("addedfile", function(file) {
            var _this = this;
            this.on("success", function(file, data) {
              var ext = file.name.split(".").pop();

              file.requestId = data.requestId;
              file.seq = data.seq;
            });
            this.on("error", function (file, message) {
              this.removeFile(file);
            }); 
          });
        },
      },
      ctrDatePEA: "",
      projectName: "",
      percentage: "",
      manyCtrNo: "",
      manyCtrDate: "",
      guaranteePriceAmt: "",
      hospitalCode: "",
      hospitalName: "",
      contractTypeId: 0,
      contractTypeDesc: "",
      contractPeriod:"",
      projectId:"",
      seqNo:"",
      projectBudgetAmt:"",
      bidExpireDate:"",
      projectOwner:"",
      advancePaymentAmt:"",
      collectionPhase:"",
      productType:"",
      dealerCode:"",
      creditBranch:{
        respUnit: "",
        branchName: ""
      },
      creditBranchOwner:"",
      manyCtrName:"",
      lgDescription3:"",
      lgDescription2:"",
      lgDescription4:"",
      lgDescription5:"",
      lgDescription6:""
    };
  },
  name: "requestMain",

  watch: {
    periodType(newval, oldval) {
      if (newval === 1) {
        this.periodAmt = "";
        this.periodUnit = "";
        this.$refs.periodStartDate1.clearDate();
        this.$refs.periodEndDate.clearDate();
      } else {
        this.$refs.periodStartDate2.clearDate();
        this.periodUnit = "mm";
      }

      Promise.all([
        this.$validator.validate("periodStartDate1"),
        this.$validator.validate("periodStartDate2"),
        this.$validator.validate("periodEndDate"),
      ]);
    },
    beneficiary(newDate, oldDate) {
      //if(this.beneficiary.beneGroup !== ''){
      if (newDate && newDate.group === "NHSO") this.isHideForm = true;
      else this.isHideForm = false;

      if (this.beneficiary.group !== "") {
        localStorage.setItem("beneGroup", this.beneficiary.group);
        localStorage.setItem("lgType", this.lgType);
      }
      this.dynamicBeneChild();
    },
    lgType(newDate, oldDate) {
      localStorage.setItem("beneGroup", this.beneficiary.group);
      localStorage.setItem("lgType", this.lgType);

      this.dynamicBeneChild();
    },
    lgFormNo() {
      this.dynamicBeneChild();
      if(this.lgFormNo === 'MEA_UTL_001_TH'){
        this.periodType = 2;
        this.$refs.periodStartDate2.clearDate();
        this.periodUnit = "mm";
      }else if(this.lgFormNo === 'MEA_UTL_002_TH'){
        this.periodAmt = "";
        this.periodType = 1;
        this.$refs.periodStartDate1.clearDate();
        this.$refs.periodEndDate.clearDate();
        this.periodUnit = "mm";
      }
    },
    accountType(){
      if(this.accountType === "COM"){
        this.savAccNo = "";
      }else if(this.accountType === "SAV"){
        this.loader = this.$loading.show();
        apiClient
          .get(
            "/api/elg/defaultRequestCashCollateral/" + localStorage.getItem("registerVerifyId")
          )
          .then((resp) => {
            this.savAccList = resp.data.cashCollAccList;
            this.loader.hide();
          })
          .catch((error) => {
            if(error.response.status===401){
              this.loader.hide();
            }
          });
        this.commNo = "";
        this.periodType = "";
        this.periodStartDate2.clearDate();
        this.periodUnit = "mm";
      }
    }
  },

  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },

    dynamicBeneChild() {
      const beneCode = this.beneficiary.group;
      const lgType = this.lgTypeObj.contingentId; //this.lgType;
      const lgFormNo = this.lgFormNo;
      // console.log("beneCode:" + beneCode);
      // console.log("lgType:" + lgType);
      return () => import(`@/components/request/new/DYNAMIC_SPECIFIC_FIELD`);
    },

    countryName() {
      return this.countries.find(
        (item) => item.value === this.content.country_code
      ).label;
    },
  },
  methods: {
    clearAll: function() {
      this.custLgTypeList = [];
      this.lgFormList = [];
      this.commList = [];
      this.requesterList = [];
      this.guaranteeList = [
        {
          guaranteeTaxId: "",
          guaranteeName: "",
          guaranteeNameEN: "",
        },
      ];

      this.lgAmt = "";
      this.dynamicBeneChild();

      this.periodType = "";
      this.periodAmt = "";
      this.periodUnit = "";
      this.periodStartDate1 = "";
      this.periodEndDate = "";
      this.periodStartDate2 = "";
      this.bcFlag = "0";
      this.docTypeList = [];

      this.accNoFee = "";
      this.accNoStamp = "";
      this.accBalFee = "0";
      this.accBalStamp = 0;
    },

    getDocTypeList: function() {
      let reqTypeStr = "";
      if (this.$parent.reqType == "1") {
        reqTypeStr = "NEW";
      } else if (this.$parent.reqType == "2") {
        reqTypeStr = "EXT";
      } else if (this.$parent.reqType == "3") {
        reqTypeStr = "INC";
      } else if (this.$parent.reqType == "4") {
        reqTypeStr = "EXTINC";
      }

      apiClient
        .get(
          "/api/home/getDocType/" +
            reqTypeStr +
            "/" +
            this.lgTypeObj.mtContingentId
        )
        .then((resp) => {
          if (resp && resp.data) {
            this.docTypeList = resp.data;
          }
        })
        .catch((error) => {
          if(error.response.status===401){
              this.loader.hide();
          }
        });
    },
    getPeriod: function(event) {
      return new Promise((resolve, reject) => {
        if (this.periodUnit === "") {
          return;
        }
        if (event === "endDate") {
          if (this.periodStartDate1 === "") {
            return;
          }
          this.loader = this.$loading.show();

          let vperiodStartDate = "-";
          let vperiodEndDate = "-";
          vperiodStartDate = moment(this.periodStartDate1).format("DD-MM-YYYY");
          vperiodEndDate = moment(this.periodEndDate).format("DD-MM-YYYY");

          apiClient
            .get(
              "/api/home/getPeriodAmtBetweenDates/" +
                vperiodStartDate +
                "/" +
                vperiodEndDate +
                "/" +
                this.periodUnit
            )
            .then((resp) => {
              this.loader.hide();
              if (resp.data) {
                this.periodAmt = resp.data;
                this.getFeeAmount();
              } else {
                this.periodAmt = "";
              }
              resolve();
            })
            .catch((error) => {
              if(error.response.status===401){
                this.loader.hide();
              }
            });
        } else {
          if (this.periodAmt === "" || this.periodStartDate1 === "") {
            return;
          }

          let vperiodStartDate = moment(this.periodStartDate1).format(
            "DD-MM-YYYY"
          );

          this.loader = this.$loading.show();
          apiClient
            .get(
              "/api/home/getEndDate/" +
                this.periodAmt +
                "/" +
                this.periodUnit +
                "/" +
                vperiodStartDate
            )
            .then((resp) => {
              this.loader.hide();

              if (resp.data !== "") {
                this.periodEndDate = moment(resp.data, "DD/MM/YYYY");
                this.errors.clear();
                this.getFeeAmount();
              } else {
                this.periodEndDate = "";
                this.errors.add({
                  field: "periodEndDate",
                  msg: "กรุณากรอก ถึงวันที่",
                });
              }
              resolve();
            })
            .catch((error) => {
              if(error.response.status===401){
                this.loader.hide();
              }
            });
        }
      });
    },

    onRequesterLChange(event, guarantee) {
      var taxId = this.requesterList[event.target.selectedIndex - 1]
        .guaranteeTaxId;
      let gName = this.requesterList[event.target.selectedIndex - 1]
        .guaranteeName;
      let gNameEN = this.requesterList[event.target.selectedIndex - 1]
        .guaranteeNameEN;

      var dup = false;
      for (var i = 0; i < this.guaranteeList.length - 1; i++) {
        if (taxId === this.guaranteeList[i].guaranteeTaxId.guaranteeTaxId) {
          dup = true;
          break;
        }
      }

      if (!dup) {
        guarantee.guaranteeName = gName;
        guarantee.guaranteeNameEN = gNameEN;
      } else {
        guarantee.guaranteeTaxId = null;
        guarantee.guaranteeName = null;
        guarantee.guaranteeNameEN = null;
        this.$swal("", "เพื่อค้ำประกันในนามซ้ำกรุณาเลือกใหม่ ", "warning");
      }
    },
    onChildChange(value) {
      this.ctrNo = value.ctrNo;
      this.ctrName = value.ctrName;
      this.ctrDate = value.ctrDate;
      this.securityNo = value.securityNo;
      this.caNo = value.caNo;
      this.meterNo = value.meterNo;
      this.bpNo = value.bpNo;
      this.jobPrice = value.jobPrice;
      this.middlePrice = value.middlePrice;
      this.beneficiaryRemark = value.beneficiaryRemark;
      this.ctrDatePEA = value.ctrDatePEA;
      this.projectName = value.projectName;
      this.percentage = value.percentage;
      this.manyCtrNo = value.manyCtrNo;
      this.manyCtrDate = value.manyCtrDate;
      this.guaranteePriceAmt = value.guaranteePriceAmt;
      this.hospitalCode = value.hospitalCode;
      this.hospitalName = value.hospitalName;
      this.contractTypeId = value.contractTypeId;
      this.contractTypeDesc = value.contractTypeDesc;
      this.contractPeriod = value.contractPeriod;
      this.projectId = value.projectId;
      this.seqNo = value.seqNo;
      this.projectBudgetAmt = value.projectBudgetAmt;
      this.bidExpireDate = value.bidExpireDate;
      this.projectOwner = value.projectOwner;
      this.advancePaymentAmt = value.advancePaymentAmt;
      this.collectionPhase = value.collectionPhase;
      this.productType = value.productType;
      this.dealerCode = value.dealerCode;
      this.manyCtrName = value.manyCtrName;
      this.lgDescription3 = value.lgDescription3;
      this.lgDescription2 = value.lgDescription2;
      this.lgDescription4 = value.lgDescription4;
      this.lgDescription5 = value.lgDescription5;
      this.lgDescription6 = value.lgDescription6;
    },
    getFormNoList: function() {
      return new Promise((resolve, reject) => {
        this.lgFormList = "";
        if (
          this.lgTypeObj.contingentId !== undefined &&
          this.lgTypeObj.contingentId != "" &&
          this.lgTypeObj.contingentId !== null
        ) {
          this.loader = this.$loading.show();
          apiClient
            .get(
              //"/api/home/getFormNo/" + this.beneficiary.beneTaxId+"/"+this.lgTypeObj.mtContingentId
              "/api/home/getFormNo/" +
                this.beneficiary.taxid +
                "/" +
                this.lgTypeObj.mtContingentId
            )
            .then((resp) => {
              this.loader.hide();
              this.lgFormList = resp.data;

              if (resp.data.length === 1) {
                this.lgFormNo = resp.data[0].lgFormNo;
              } else if (resp.data.length > 0) {
                this.lgFormNo = "";
              } else {
                this.lgFormNo = "";
                this.$swal(
                  "",
                  "ไม่พบแบบฟอร์มสำหรับประเภทการค้ำกันนี้",
                  "error"
                );
              }
              resolve();
            })
            .catch((error) => {
              if(error.response.status===401){
                this.loader.hide();
              }
            });
        }
      });
    },

    getCommitmentList: function() {
      return new Promise((resolve, reject) => {
        if (
          this.lgTypeObj.contingentId !== undefined &&
          this.lgTypeObj.contingentId != "" &&
          this.lgTypeObj.contingentId !== null
        ) {
          this.loader = this.$loading.show();
          apiClient
            .get(
              //"/api/elg/getCreditLimitAccount/" + this.lgTypeObj.contingentId+"/"+this.beneficiary.beneTaxId
              "/api/elg/getCreditLimitAccount/" +
                this.lgTypeObj.contingentId +
                "/" +
                this.beneficiary.taxid
            )
            .then((resp) => {
              this.loader.hide();
              this.commList = resp.data;

              this.guaranteeList[0].guaranteeTaxId = {
                guaranteeTaxId: "",
                guaranteeName: "",
                guaranteeNameEN: "",
              };

              if (resp.data.length > 1) {
                this.commNo = "";
                this.bcFlag = "0";
              } else if (resp.data.length == 1) {
                this.commNo = resp.data[0].accountNo;
                this.bcFlag = resp.data[0].accountBlockChain;
              } else {
                this.commNo = "";
                this.bcFlag = "0";
                this.$swal("", "ไม่พบวงเงินสำหรับประเภทการค้ำประกันนี้", "error");
              }

              resolve();
            })
            .catch((error) => {
              this.loader.hide();
            });
        }
      });
    },

    getFeeAmount: function() {
      return new Promise((resolve, reject) => {
        if (
          this.commNo !== undefined &&
          this.commNo != "" &&
          this.commNo !== null &&
          this.lgTypeObj.contingentId !== undefined &&
          this.lgTypeObj.contingentId != "" &&
          this.lgTypeObj.contingentId !== null &&
          this.lgAmt !== undefined &&
          this.lgAmt != "" &&
          this.lgAmt !== null &&
          this.lgAmt > 0
        ) {
          let vperiodStartDate = "-";
          let vperiodEndDate = "-";
          if (this.periodType == 2) {
            if (
              this.periodStartDate1 !== null &&
              this.periodStartDate1 !== undefined &&
              this.periodStartDate1 !== "" &&
              this.periodEndDate !== null &&
              this.periodEndDate !== undefined &&
              this.periodEndDate !== ""
            ) {
              vperiodStartDate = moment(this.periodStartDate1).format(
                "YYYYMMDD"
              );
              vperiodEndDate = moment(this.periodEndDate).format("YYYYMMDD");
            }
          } else {
            if (
              this.periodStartDate2 !== null &&
              this.periodStartDate2 !== undefined &&
              this.periodStartDate2 !== ""
            ) {
              vperiodStartDate = moment(this.periodStartDate2).format(
                "YYYYMMDD"
              );
            }
          }

          apiClient
            .get(
              "/api/elg/getFeeAmount/" +
                this.commNo +
                "/" +
                this.lgTypeObj.contingentId +
                //this.lgType +
                "/" +
                this.lgAmt +
                "/" +
                vperiodStartDate +
                "/" +
                vperiodEndDate +
                "/0/" +
                this.$parent.reqType +
                "/" +
                this.beneficiary.taxid
            )
            .then((resp) => {
              if (resp.data.feeAmount !== null) {
                this.feeAmt = resp.data.feeAmount;
              }

              resolve();
            })
            .catch((error) => {
              if(error.response.status===401){
                this.loader.hide();
              }
            });
        }else{
          resolve();
        }
      });
    },

    getStampAmt: function() {
      if (this.lgAmt !== undefined && this.lgAmt != "" && this.lgAmt !== null) {
        if (this.lgAmt <= 1000) {
          this.majorStampAmt = 1;
          this.dutyStampAmt = 1;
        } else if (this.lgAmt <= 10000) {
          this.majorStampAmt = 5;
          this.dutyStampAmt = 5;
        } else {
          this.majorStampAmt = 10;
          this.dutyStampAmt = 10;
        }
      }
    },

    setAccBalStamp() {
      this.accNoStamp = this.accNoStampItem.accountNo;
      this.accBalStamp = this.accNoStampItem.availBalAmt;
    },
    setAccBalFee() {
      this.accNoFee = this.accNoFeeItem.accountNo;
      this.accBalFee = this.accNoFeeItem.availBalAmt;
      this.accNoStamp = this.accNoFeeItem.accountNo;
      this.accBalStamp = this.accNoFeeItem.availBalAmt;
      this.accNoStampItem = this.accNoFeeItem;

      /*this.accNoStampItem = this.accNoFeeItem;
      this.accNoStamp = this.accNoStampItem.accountNo;
      this.accBalStamp = this.accNoStampItem.availBalAmt;*/
    },
    setSaveAcc() {
      this.savAccNo = this.savAccNoItem.accountNo;
      this.savAccNoBal = this.savAccNoItem.availBal;
    },

    addGuarantee() {
      this.guaranteeList.push({
        guaranteeTaxId: "",
        guaranteeName: "",
        guaranteeNameEN: "",
      });
    },

    removeGuarantee: function(index) {
      if (this.guaranteeList.length > 1) {
        this.guaranteeList.splice(index, 1);
      }
    },

    getGuaranteeList: function() {
      for (var i = 1; i <= this.guaranteeList.length - 1; i++) {
        this.guaranteeList.splice(i);
      }
    },

    getLgTypeList: function() {
      return new Promise((resolve, reject) => {
        if (this.beneficiary.taxid == undefined) {
          this.clearAll();
          return;
        }

        this.lgTypeObj = "";
        this.lgFormNo = "";
        this.loader = this.$loading.show();
        apiClient
          //.get("/api/home/getBeneficiaryProfile/" + this.beneficiary.beneTaxId)
          .get("/api/home/getContingentByTaxId/" + this.beneficiary.taxid)
          .then((resp) => {
            this.loader.hide();
            this.custLgTypeList = resp.data;

            if (resp.data.length == 1) {
              this.lgTypeObj = {
                contingentId: resp.data[0].contingentTypeId,
                mtContingentId: resp.data[0].mtContingentId,
                //lgFormNo: resp.data[0].lgFormNo
              };
            }

            resolve();
          })
          .catch((error) => {
            if(error.response.status===401){
              this.loader.hide();
            }
          });
      });
    },

    getDefaultGuaranteeList: function() {
      //console.log("getDefaultGuaranteeList");
      //console.log("this.appVo.requesterTaxId : "+this.appVo.requesterTaxId);
      //console.log("this.appVo.requesterNameTh : "+this.appVo.requesterNameTh);
      //console.log("this.appVo.requesterNameEn : "+this.appVo.requesterNameEn);
      return new Promise((resolve, reject) => {
        this.guaranteeList = [
                {
                  guaranteeTaxId: "",
                  guaranteeName: "",
                  guaranteeNameEN: "",
                },
              ];

        this.requesterList.push({
                guaranteeTaxId: this.appVo.requesterTaxId,
                guaranteeName: this.appVo.requesterNameTh,
                guaranteeNameEN: this.appVo.requesterNameEn,
              });
        
        this.guaranteeList[0].guaranteeTaxId = {
          guaranteeTaxId: this.appVo.requesterTaxId,
          guaranteeName: this.appVo.requesterNameTh,
          guaranteeNameEN: this.appVo.requesterNameEn,
        };
        this.guaranteeList[0].guaranteeName = this.appVo.requesterNameTh;
        this.guaranteeList[0].guaranteeNameEN = this.appVo.requesterNameEn;

        //set accNoFee ตาม
        if(this.savAccNoItem.productGroup =='SAV'){
          this.accNoFeeItem = this.savAccNoItem;
          this.accNoStampItem = this.savAccNoItem;
          this.accNoFee = this.accNoFeeItem.accountNo;
          this.accBalFee = this.accNoFeeItem.availBalAmt;
          this.accNoStamp = this.accNoFeeItem.accountNo;
          this.accBalStamp = this.accNoFeeItem.availBalAmt;
        }
      });

      
    },
    getAccountByCommNo: function() {
      return new Promise((resolve, reject) => {
        if (this.commNo === null && this.commNo === "") {
          if (this.commList !== null) {
            if (this.commList.length == 1) {
              this.commNo = this.commList[0].accountNo;
              this.bcFlag = this.commList[0].accountBlockChain;
            } else {
              this.commNo = "";
              this.bcFlag = "0";
            }
          }
        } else {
          if (this.$refs.scommNo.selectedIndex > 0) {
            this.bcFlag = this.commList[
              this.$refs.scommNo.selectedIndex - 1
            ].accountBlockChain;
          }
        }

        if (this.commNo === "") {
          this.loader.hide();
          return;
        } else {
          this.loader = this.$loading.show();
          apiClient
            //.get("/api/elg/defaultCard/" + this.commNo)
            .get("/api/elg/defaultCard/" + this.commNo+"/"+this.lgTypeObj.mtContingentId)
            .then((resp) => {
              //reset ข้อมูลเดิม
              this.requesterList = [];
              this.guaranteeList = [
                {
                  guaranteeTaxId: "",
                  guaranteeName: "",
                  guaranteeNameEN: "",
                },
              ];

              this.requesterList.push({
                guaranteeTaxId: this.appVo.requesterTaxId,
                guaranteeName: this.appVo.requesterNameTh,
                guaranteeNameEN: this.appVo.requesterNameEn,
              });

              if (resp.data !== "" && resp.data.requesterList.length > 0) {
                for (var i = 0; i < resp.data.requesterList.length; i++) {
                  this.requesterList.push({
                    guaranteeTaxId: resp.data.requesterList[i].guaranteeTaxId,
                    guaranteeName: resp.data.requesterList[i].guaranteeName,
                    guaranteeNameEN: resp.data.requesterList[i].guaranteeNameEN,
                  });
                }
              } else {
                this.guaranteeList[0].guaranteeTaxId = {
                  guaranteeTaxId: this.appVo.requesterTaxId,
                  guaranteeName: this.appVo.requesterNameTh,
                  guaranteeNameEN: this.appVo.requesterNameEn,
                };
                this.guaranteeList[0].guaranteeName = this.appVo.requesterNameTh;
                this.guaranteeList[0].guaranteeNameEN = this.appVo.requesterNameEn;
              }

              if (
                resp.data !== "" &&
                resp.data.feeDebitAccountList !== null &&
                resp.data.feeDebitAccountList.length > 0 &&
                resp.data.feeDebitAccountList[0].accountNo !== ""
              ) {
                this.loader.hide();
                this.accNoFee = resp.data.feeDebitAccountList[0].accountNo;
                this.accNoStamp = resp.data.feeDebitAccountList[0].accountNo;
                this.accBalFee =
                  resp.data.feeDebitAccountList[0].availableBalance;
                this.accBalStamp =
                  resp.data.feeDebitAccountList[0].availableBalance;
                this.effectivePassDay = moment(
                  resp.data.effectivePassDay,
                  "DD/MM/YYYY"
                );

                resolve();
              } else {
                this.accNoFee = "";
                this.accNoStamp = "";
                this.accBalFee = 0;
                this.accBalStamp = 0;

                this.loader.hide();
                this.$swal(
                  "",
                  "ยังไม่บันทึกข้อมูลบัญชีค่าธรรมเนียม กรุณาติดต่อธนาคาร ",
                  "error"
                );
                resolve();
              }
            })
            .catch((error) => {
              this.loader.hide();
            });
        }
      });
    },

    initUpload(refName, doctypeId) {
      this.refDropZone = refName;

      //let myUrl = process.env.VUE_APP_ROOT_API + "/api/elg/attachFile/" + localStorage.getItem("registerVerifyId") + "/" + this.reqNo + "/" + doctypeId;
      let myUrl = process.env.VUE_APP_ROOT_API + "/api/elg/attachFile/" + localStorage.getItem("registerVerifyId") + "/" + doctypeId;
      this.$refs[refName][0].setOption("url", myUrl);
      this.$refs[refName][0].options.url = myUrl;
    },
    imageRemoved(file) {
      let requestId = file.requestId;
      let seq = file.seq;
      console.log("image removed seq: "+seq);
      if (requestId !== undefined && seq !== undefined) {
        this.loader = this.$loading.show();
        //apiClient.get("/api/elg/removeFileUpload/" + requestId + "/" + seq);
        apiClient.get("/api/elg/removeFileUpload/" + seq);
        this.loader.hide();
      }
    },
    successUpload(file, data) {
      console.log("upload success");
      console.log("data.code :"+data.code);
      if (data.code === "0000") {//เก็บ docSeq ไว้เพื่อ update REQUEST_ID ตอนกด บันทึก
          console.log("data.seq = "+data.seq);
          if(this.docSeq !==""){
            this.docSeq = this.docSeq+"|"+data.seq;
          }else{
            this.docSeq = data.seq;
          }
          console.log("this.docSeq = "+this.docSeq);
      }else if (data.code === "0001") {
        this.$refs[this.refDropZone][0].removeFile(file);
        this.$swal(
          "",
          "ไม่สามารถ Upload เอกสารแนบได้ กรุณา Upload เอกสารแนบ " +
            file.name +
            " ใหม่อีกครั้ง",
          "error"
        );
      }
    },

    uploadError: function(file) {
      //this.$refs[dropzone0][0].removeFile(file); 
      this.$swal(
        "",
        "รูปแบบไฟล์แนบหรือขนาดไฟล์ไม่ถูกต้อง (แนบได้ไม่เกิน 10 ไฟล์ เฉพาะ PDF และ รูป ขนาดไม่เกิน 10MB)",
        "error"
      );
    },

    updateValue(value) {
      this.$emit("input", value);
    },

    getLGTypeName(mtLgType) {
      const result = this.custLgTypeList.filter((member) => {
        return member.mtContingentId == mtLgType;
      });

      return result[0].contingentTypeNameTh;
    },
    escapeHtml: function(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    validateBeforeSubmit: function() {
      const { reqNo, reqType, periodStartDate1, beneficiary } = this;
      //if(this.$refs.input.selectedIndex === 0){
      if (
        this.beneficiary.taxid === undefined ||
        this.beneficiary.taxid === null ||
        this.beneficiary.taxid === ""
      ) {
        this.$swal("Error", "กรุณาระบุ ผู้รับผลประโยชน์", "error");
        return;
      }
      if (this.$refs.refLgType.selectedIndex === 0) {
        this.$swal("Error", "กรุณาระบุ ประเภทค้ำประกัน", "error");
        return;
      }
      if (this.$refs.refLgFormNo.selectedIndex === 0) {
        this.$swal("Error", "กรุณาระบุ รหัสแบบฟอร์มหนังสือค้ำประกัน", "error");
        return;
      }
      if (this.$refs.scommNo.selectedIndex === 0 && this.accountType === 'COM') {
        this.$swal("Error", "กรุณาระบุ หมายเลขบัญชีวงเงิน", "error");
        return;
      }
/*
      if(this.accountType === 'SAV'){
        if(this.accNoFee =="" ){
            this.$swal("Error", "กรุณาระบุ หมายเลขบัญชีวงเงิน", "error");
            return;
        }else if(this.accountType === "SAV"){
          this.commNo = "";
        }
      }*/

      var countAllFile = 0;
      for (var i = 0; i < this.docTypeList.length; i++) {
        let required_file = this.docTypeList[i].mandatFlag;
        if (
          required_file === "Y" &&
          this.$refs["myVueDropzone" + i][0].dropzone.files.length < 1
        ) {
          this.$swal("Error", "กรุณาแนบเอกสารประกอบเพิ่มเติม ", "error");
          return;
        }
        countAllFile =
          countAllFile +
          this.$refs["myVueDropzone" + i][0].dropzone.files.length;
      }

    //const beneCode = this.beneficiary.beneGroup;
      const lgType = this.custLgTypeList[
        this.$refs.refLgType.selectedIndex - 1
      ].contingentTypeId; //this.lgType;
      this.lgType = this.custLgTypeList[
        this.$refs.refLgType.selectedIndex - 1
      ].contingentTypeId;

    if(this.accountType === 'COM'){
      if (
        this.commList != null &&
        this.commList.length != undefined &&
        this.commList.length > 0
      ) {
        const accountBlockChain = this.commList[
          this.$refs.scommNo.selectedIndex - 1
        ].accountBlockChain;
        

        //ถ้าเป็นวงเงินกระดาษต้องมีไฟล์แนบ  หรือ ถ้าเป็น SCG ประเภท ปฏิบัติตามสัญญา performance bond และวงเงินที่เป็น eLG
        if (
          ((accountBlockChain === 1 || accountBlockChain === "") &&
            countAllFile <= 0) ||
          (lgType === "3" && countAllFile <= 0)
          //||(beneCode==="SCG"&&lgType==="3"&&countAllFile<=0)
        ) {
          this.$swal("Error", "กรุณาแนบเอกสารประกอบเพิ่มเติม ", "error");
          return;
        }
      }

      //check file size max 10 files.
      if (countAllFile > 10) {
        this.$swal(
          "Error",
          "ขนาดไฟล์ไม่ถูกต้อง (แนบได้ทั้งหมดไม่เกิน 10 ไฟล์)",
          "error"
        );
        return;
      }
    }else{//cash collateral
      this.savAccNo = this.savAccNoItem.accountNo;
      this.savAccNoBal = this.savAccNoItem.availBal;
      //console.log("this.appVo.branchOwnerFlg = "+this.appVo.branchOwnerFlg);
      //console.log("this.creditBranch.respUnit = "+this.creditBranch.respUnit);
      if(this.creditBranch.respUnit === undefined || this.creditBranch.respUnit === null || this.creditBranch.respUnit == ""){
        this.$swal("Error", "กรุณาระบุสาขาที่ต้องการลงนามสัญญาสินเชื่อ", "error");
          return;
      }
      if(this.lgAmt>this.savAccNoBal){
        this.$swal("Error", "กรุณาระบุจำนวนเงินที่ค้ำประกันน้อยกว่าหรือเท่ากับจำนวนเงินในบัญชีเงินฝาก", "error");
          return;
      }
    }

      //const { feeAmt, dutyStampAmt, accBalFee } = this;

      /*เอาออกจาก defect join and เพื่อรองรับ Overdraft Account Linkage
      if (feeAmt + dutyStampAmt > accBalFee) {
        this.$swal
          .fire({
            title: "",
            width: 700,
            html:
              "จำนวนเงินในบัญชีไม่พอให้ตัดค่าธรรมเนียม/ค่าอากรแสตมป์ <br/>กรุณานำเงินเข้าบัญชี เพื่อหักชำระค่าธรรมเนียม/ค่าอากรแสตมป์ การออกหนังสือค้ำประกัน",
            type: "error",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ตกลง"
          });

        return;
      }*/

      this.$validator.validateAll().then((result) => {
        if (result) {
          var periodDateStr = "";

          if (this.periodType == 2) {
            periodDateStr =
              this.$refs.periodStartDate1.text +
              " ถึง " +
              this.$refs.periodEndDate.text;
          } else {
            periodDateStr = this.$refs.periodStartDate2.text;
          }

          var strRequest = "";
          if (this.guaranteeList != null && this.guaranteeList.length > 0) {
            for (var i = 0; i < this.guaranteeList.length; i++) {
              strRequest =
                strRequest +
                "<li>" +
                this.escapeHtml(
                  this.guaranteeList[i].guaranteeTaxId.guaranteeTaxId
                ) +
                " : " +
                this.escapeHtml(this.guaranteeList[i].guaranteeName) +
                "</li>";
            }
          }

          var strFee = "ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร";
          if (this.bcFlag === "1") {
            strFee = this.formatPrice(this.feeAmt);
          } else {
            this.feeAmt = null;
          }

          this.$swal
            .fire({
              title: "กรุณาตรวจสอบรายละเอียดก่อนดำเนินการ?",
              width: 600,
              html:
                "<div class='card-body compact-padding'>" +
                "  <div class='default-padding'>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>หมายเลขอ้างอิงรายการ</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                reqNo +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ผู้ขอออกหนังสือค้ำประกัน</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.escapeHtml(this.appVo.requesterTaxId) +
                " " +
                this.escapeHtml(this.appVo.requesterNameTh) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ผู้รับผลประโยชน์</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.escapeHtml(this.beneficiary.nameTH) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ประเภทการค้ำประกัน</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.getLGTypeName(this.lgTypeObj.mtContingentId) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>เพื่อค้ำประกันในนาม</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strRequest +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>จำนวนเงินค้ำประกัน (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.formatPrice(this.lgAmt) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>มีผลบังคับใช้ตั้งแต่วันที่</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                periodDateStr +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ค่าธรรมเนียม (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strFee +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ค่าอากรแสตมป์ (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.formatPrice(this.dutyStampAmt) +
                " " +
                "      </div>" +
                "    </div>" +
                "  </div>" +
                "</div>",

              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              cancelButtonText: "ยกเลิก",
              confirmButtonText: "ยืนยันการทำรายการ",
            })
            .then((result) => {
              if (result.value) {
                if (this.$parent.reqType == "1") {
                  this.reqType = "NEW";
                } else if (this.$parent.reqType == "2") {
                  this.reqType = "EXT";
                } else if (this.$parent.reqType == "3") {
                  this.reqType = "INC";
                } else if (this.$parent.reqType == "4") {
                  this.reqType = "EXTINC";
                }

                let vperiodStartDate = "";
                let vperiodEndDate = "";

                if (this.periodType == 2) {
                  vperiodStartDate = moment(this.periodStartDate1).format(
                    "YYYYMMDD"
                  );
                  vperiodEndDate = moment(this.periodEndDate).format(
                    "YYYYMMDD"
                  );
                } else {
                  vperiodStartDate = moment(this.periodStartDate2).format(
                    "YYYYMMDD"
                  );
                }

                if (vperiodStartDate == "Invalid date") {
                  vperiodStartDate = "";
                }
                if (vperiodEndDate == "Invalid date") {
                  vperiodEndDate = "";
                }

                let vctrDate = "";
                if (
                  typeof this.ctrDate !== undefined &&
                  this.ctrDate !== ""
                ) {
                  vctrDate = moment(this.ctrDate).format("YYYYMMDD");
                }
                if (vctrDate === "Invalid date") {
                  vctrDate = "";
                }

                let vCtrDatePEA = "";
                if (this.ctrDatePEA !== undefined && this.ctrDatePEA !== "") {
                  vCtrDatePEA = moment(this.ctrDatePEA).format("YYYYMMDD");
                }
                if (vCtrDatePEA === "Invalid date") {
                  vCtrDatePEA = "";
                }
                
                let vBidExpireDate = "";
                if (this.bidExpireDate !== undefined && this.bidExpireDate !== "") {
                  vBidExpireDate = moment(this.bidExpireDate).format("YYYYMMDD");
                }
                if (vBidExpireDate === "Invalid date") {
                  vBidExpireDate = "";
                }

                let vLgDescription4 = "";
                if (this.lgDescription4 !== "undefined" && this.lgDescription4 !== "") {
                  vLgDescription4 = moment(this.lgDescription4).format("YYYYMMDD");
                }
                if (vLgDescription4 === "Invalid date") {
                  vLgDescription4 = "";
                }
                console.log("this.docSeq = "+this.docSeq);
                this.loader = this.$loading.show();
                apiClient
                  .post(
                    "/api/elg/request/" +
                      localStorage.getItem("registerVerifyId"),
                    {
                      reqNo: reqNo,
                      status: "PS",
                      reqType: this.reqType,
                      cifNo: localStorage.getItem("cifNo"),
                      requesterTaxId: this.appVo.requesterTaxId,
                      requesterNameTh: this.appVo.requesterNameTh,
                      requesterNameEn: this.appVo.requesterNameEn,
                      //beneTaxId: this.beneficiary.beneTaxId,
                      beneTaxId: this.beneficiary.taxid,
                      contingentTypeId: this.lgType,
                      lgAmt: this.lgAmt,
                      periodType: this.periodType,
                      periodStartDate: vperiodStartDate,
                      periodEndDate: vperiodEndDate,
                      periodAmt: this.periodAmt,
                      periodUnitId: this.periodUnit,
                      commNo: this.commNo,
                      feeCcy: "THB",
                      lgCcy: "THB",

                      guaranteeList: this.guaranteeList,
                      requesterList: this.convertGuaranteeList(),
                      feeAmt: this.feeAmt,
                      accNo: this.accNoFee,
                      caNo: this.caNo,
                      securityNo: this.securityNo,
                      bpNo: this.bpNo,
                      meterNo: this.meterNo,
                      jobPrice: this.jobPrice,
                      middlePrice: this.middlePrice,
                      ctrNo: this.ctrNo,
                      ctrName: this.ctrName,
                      ctrDate: vctrDate,
                      bcFlag: this.bcFlag,
                      beneficiaryRemark: this.beneficiaryRemark,
                      lgFormNo: this.lgFormNo,
                      mtContingentId: this.lgTypeObj.mtContingentId,
                      ctrDatePEA: vCtrDatePEA,
                      projectName: this.projectName,
                      percentage: this.percentage,
                      majorStampAmt: this.majorStampAmt,
                      dutyStampAmt: this.dutyStampAmt,
                      manyCtrNo: this.manyCtrNo,
                      manyCtrDate: this.manyCtrDate,
                      guaranteePriceAmt: this.guaranteePriceAmt,
                      hospitalCode: this.hospitalCode,
                      hospitalName: this.hospitalName,
                      contractTypeId: this.contractTypeId,
                      contractTypeDesc: this.contractTypeDesc,
                      contractPeriod: this.contractPeriod,
                      projectId: this.projectId,
                      seqNo: this.seqNo,
                      projectBudgetAmt: this.projectBudgetAmt,
                      bidExpireDate: vBidExpireDate,
                      projectOwner: this.projectOwner,
                      advancePaymentAmt: this.advancePaymentAmt,
                      collectionPhase: this.collectionPhase,
                      productType: this.productType,
                      dealerCode: this.dealerCode,
                      docSeq: this.docSeq,
                      accountType: this.accountType,
                      savAccNo: this.savAccNo,
                      accNoStamp: this.accNoStamp,
                      creditBranchOwner: this.creditBranch.respUnit,
                      manyCtrName: this.manyCtrName,
                      lgDescription3: this.lgDescription3,
                      lgDescription2: this.lgDescription2,
                      lgDescription4: vLgDescription4,
                      lgDescription5: this.lgDescription5,
                      lgDescription6: this.lgDescription6
                    }
                  )
                  .then((resp) => {
                    this.loader.hide();
                    if (resp.data.code == "0000") {
                      //success
                      this.$swal("", "บันทึกส่งข้อมูลเรียบร้อย\n หมายเลขอ้างอิงรายการ : "+resp.data.requestId, "success");
                      this.$router.push("/apphistory");
                    } else {
                      this.$swal(
                        "",
                        "ดำเนินการไม่สำเร็จ " + resp.data.message,
                        "error"
                      );
                    }
                  })
                  .catch((error) => {
                    if(error.response.status===401){
                      this.loader.hide();
                    }
                  });
              } else {
                //ถ้ากดยกเลิก
              }
            });
        } else {
          this.$swal("", "กรุณากรอกข้อมูลให้ครบถ้วน ", "error");
        }
      });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    convertGuaranteeList() {
      var glist = new Array(this.guaranteeList.length);

      for (var i = 0; i < this.guaranteeList.length; i++) {
        glist[i] = {
          guaranteeTaxId: this.guaranteeList[i].guaranteeTaxId.guaranteeTaxId,
          guaranteeName: this.guaranteeList[i].guaranteeName,
          guaranteeNameEN: this.guaranteeList[i].guaranteeNameEN,
        };
      }
      return glist;
    },
  },

  mounted() {
    this.loader = this.$loading.show();
    apiClient
      .get(
        "/api/elg/defaultRequest/" + localStorage.getItem("registerVerifyId")
      )
      .then((resp) => {
        this.appVo = resp.data;
        this.reqNo = resp.data.reqNo;
        this.majorStampAmt =
          resp.data.majorStampAmt === null ? 0 : resp.data.majorStampAmt;
        //this.minorStampAmt =
        //  resp.data.minorStampAmt === null ? 0 : resp.data.minorStampAmt;
        this.dutyStampAmt = resp.data.dutyStampAmt === null ? 0 : resp.data.dutyStampAmt;
        this.feeAccList = resp.data.savAccList;
        this.stampAccList = resp.data.savAccList;
        this.creditBranchList = resp.data.creditBranchList;

        localStorage.setItem("reqNo", resp.data.reqNo);

        apiClient.get("/api/home/getBeneficiary").then((resp) => {
          this.beneficiaryList = resp.data;
          this.beneficiary = "";
          /*
          if (
            localStorage.getItem("beneTaxId") === null ||
            localStorage.getItem("beneTaxId") === undefined ||
            localStorage.getItem("beneTaxId") === ""
          ) {
            this.beneficiary = {
              beneTaxId: this.beneficiaryList[0].taxid,
              beneGroup: this.beneficiaryList[0].group,
              beneName: this.beneficiaryList[0].nameTH
            };
          } else {
            this.beneficiary = {
              beneTaxId: localStorage.getItem("beneTaxId"),
              beneGroup: localStorage.getItem("beneGroup"),
              beneName: localStorage.getItem("beneName")
            };
          }
          
          //hot
          apiClient
            .get(
              "/api/home/getContingentByTaxId/" + this.beneficiary.beneTaxId
            )
            .then(resp => {
              this.custLgTypeList = resp.data;
              if (
                this.beneficiary.beneTaxId ===
                  localStorage.getItem("beneTaxId") &&
                this.beneficiary.beneGroup ===
                  localStorage.getItem("beneGroup") &&
                this.beneficiary.beneName === localStorage.getItem("beneName")
              ) {
                if (
                  localStorage.getItem("mtContingentId") === null ||
                  localStorage.getItem("mtContingentId") === undefined ||
                  localStorage.getItem("mtContingentId") === ""
                ) {
                  this.lgTypeObj = {
                    contingentId: resp.data[0].contingentTypeId,
                    mtContingentId: resp.data[0].mtContingentId
                    //lgFormNo: resp.data[0].lgFormNo
                  };
                } else {
                  this.lgTypeObj = {
                    contingentId: localStorage.getItem("contingentId"),
                    mtContingentId: localStorage.getItem("mtContingentId")
                    //lgFormNo: localStorage.getItem("lgFormNo")
                  };
                }
              }else{
                this.lgTypeObj = {
                    contingentId: resp.data[0].contingentTypeId,
                    mtContingentId: resp.data[0].mtContingentId
                    //lgFormNo: resp.data[0].lgFormNo
                  };
              }

            this.getDocTypeList();
            this.getFormNoList()
            .then(() => {
              return this.getCommitmentList()
            })
            .then(() => {
              return this.getAccountByCommNo();
            })
            .then(() => {
              return this.getFeeAmount();
            });
          });
          */
          this.loader.hide();
        })
        .catch((error) => {
          if(error.response.status===401){
              this.loader.hide();
          }
        });
      })
      .catch((error) => {
        if(error.response.status===401){
          this.loader.hide();
        }
      });
    this.lgAmt = localStorage.getItem("amount");
  },
};
</script>
<style>
.v_align {
  vertical-align: top;
}
.period {
  display: flex;
}
input#periodAmt {
  width: 150px;
  margin-left: 20px;
}
select#periodUnit {
  margin-left: 5px;
  width: 100px;
}
.result-bold {
  font-weight: bold;
}
.result-center {
  text-align: center;
}
.hideForm {
  display: none;
}
</style>
